export default __webpack_public_path__ + "static/media/login-dashboard-header.1db6aad2.svg";